export default __webpack_public_path__ + "static/media/meal-moderate-black.5d91cc7e.svg";